<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    full: {
      type: Boolean,
      default: false,
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    body() {
      return {
        wrap: this.wrap,
        'wrap--full': this.full,
      };
    },
  },
};
</script>
<template>
  <div class="template-item">
    <slot name="header">
      <div class="wrap">
        <TemplateHeader :title="title | locale" title-full>
          <slot name="header-btn" slot="right"></slot>
        </TemplateHeader>
      </div>
    </slot>
    <div
      class="template-item__body"
      :class="body"
    >
      <slot></slot>
    </div>
    <Load
      v-if="loading"
      fixed
    />
  </div>
</template>
<style lang="scss">
  .template-item {
    min-height: 100vh;

    &__body {
      min-height: calc(100vh - 66px);

      &.wrap {
        padding: 24px;
      }
    }

    .wrap {
      padding-left: 24px;
      padding-right: 24px;
      max-width: 1200px;
      margin: 0 auto;
    }

    .wrap--full {
      height: calc(100vh - 66px);
    }
  }

  @media (max-height: 600px) {
    .template-item {
      &__body {
        min-height: calc(100vh - 44px);
      }

      .wrap {
        padding: 16px;
      }

      .card {
        margin-bottom: 16px;
        padding: 16px;
      }

      .card-title {
        padding-bottom: 16px;
      }

      .card-tabs {
        margin: -16px -16px 16px -16px;
      }

      .col-span {
        padding: 0 8px;
      }

      .row-span {
        margin: 0 -8px;
      }

      .card-body--full {
        margin: -16px;
      }
    }
  }
</style>
